"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var Modal_style_1 = require("./Modal.style");
exports.Modal = function (props) {
    var children = props.children, show = props.show, name = props.name, onHide = props.onHide;
    return (react_1.default.createElement(react_1.default.Fragment, null, show && (react_1.default.createElement(Modal_style_1.ModalContainerStyle, null,
        react_1.default.createElement("div", { className: "modal-container" },
            react_1.default.createElement("div", { className: "bg-background" }),
            react_1.default.createElement("div", { className: "modal-content" },
                react_1.default.createElement(react_1.default.Fragment, null, children)))))));
};
exports.Modal.Body = function ModalBody(props) {
    var children = props.children, show = props.show, name = props.name, onHide = props.onHide, rest = __rest(props, ["children", "show", "name", "onHide"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal_style_1.ModalStyle, __assign({}, rest), children)));
};
//# sourceMappingURL=Modal.js.map